/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Jobs_SelectedInputs */

const en_jobs_selected = /** @type {(inputs: Jobs_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} jobs selected`)
};

const fr_jobs_selected = /** @type {(inputs: Jobs_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} emplois sélectionnés`)
};

const de_jobs_selected = /** @type {(inputs: Jobs_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Jobs ausgewählt`)
};

const it_jobs_selected = /** @type {(inputs: Jobs_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} posti di lavoro selezionati`)
};

const ru_jobs_selected = /** @type {(inputs: Jobs_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} выбраны вакансии`)
};

const es_jobs_selected = /** @type {(inputs: Jobs_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} trabajos seleccionados`)
};

const zh_cn2_jobs_selected = /** @type {(inputs: Jobs_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已选择 ${i?.count} 工作`)
};

const ja_jobs_selected = /** @type {(inputs: Jobs_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ジョブが選択されました`)
};

const hi_jobs_selected = /** @type {(inputs: Jobs_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} नौकरियां चयनित`)
};

const pt_pt2_jobs_selected = /** @type {(inputs: Jobs_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} vagas selecionadas`)
};

/**
* | output |
* | --- |
* | "{count} jobs selected" |
*
* @param {Jobs_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const jobs_selected = /** @type {((inputs: Jobs_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_jobs_selected(inputs)
	if (locale === "de") return de_jobs_selected(inputs)
	if (locale === "it") return it_jobs_selected(inputs)
	if (locale === "ru") return ru_jobs_selected(inputs)
	if (locale === "es") return es_jobs_selected(inputs)
	if (locale === "zh-CN") return zh_cn2_jobs_selected(inputs)
	if (locale === "ja") return ja_jobs_selected(inputs)
	if (locale === "hi") return hi_jobs_selected(inputs)
	if (locale === "pt-PT") return pt_pt2_jobs_selected(inputs)
	return en_jobs_selected(inputs)
});